import React from 'react';

export interface QuickReplyBarProps {
  /** 快捷回复选项列表 */
  readonly replies: readonly string[];
  /** 点击某个快捷回复 */
  readonly onQuickReply: (text: string) => void;
  /** 是否禁用（AI 回复中） */
  readonly disabled?: boolean;
}

/**
 * 快捷回复按钮栏
 * 当 AI 回复中包含建议的回复文本（如"确认生成"）时，在输入框上方显示可点击的按钮。
 */
export const QuickReplyBar: React.FC<QuickReplyBarProps> = ({
  replies,
  onQuickReply,
  disabled = false,
}) => {
  if (replies.length === 0) return null;

  return (
    <div className="quick-reply-bar">
      <span className="quick-reply-bar__label">
        <i className="fas fa-reply" />
        快捷回复
      </span>
      <div className="quick-reply-bar__items">
        {replies.map((text) => (
          <button
            key={text}
            type="button"
            className="quick-reply-bar__btn"
            disabled={disabled}
            onClick={(e) => {
              e.stopPropagation();
              onQuickReply(String(text));
            }}
            title={text}
          >
            {text}
          </button>
        ))}
      </div>
    </div>
  );
};
